export default __webpack_public_path__ + "picker.082df6d7b82f2276.svg";